export default "__VITE_ASSET__BmLhqVjJ__"